import { render } from "./Antecedente.vue?vue&type=template&id=ea989448&scoped=true"
import script from "./Antecedente.vue?vue&type=script&lang=js"
export * from "./Antecedente.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=ea989448&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea989448"]])

export default __exports__